import { SelectOptionModel } from "../models/select-option.model";

export type PersonType = "Natural" | "Legal";

export enum enumPersonType {
  "Legal" = 'Legal',
  "Natural" = 'Natural',

}

export enum enumPersonTypeTranslate {
  "Pessoa Jurídica" = 'Legal',
  "Pessoa Física" = 'Natural',
}

export function enumPersonTypeAsArray() {
  const personType = enumPersonTypeTranslate;
  return Object.keys(personType).map(type => { return new SelectOptionModel<PersonType>(type, enumPersonTypeTranslate[type]) })
}

